import DetailNotifySolitonUser from 'page/Application/ManageProductAndService/TopPageProductSolitonUser/DetailNotifySolitonUser';
import TopPageProductDetailSolitonUser from 'page/Application/ManageProductAndService/TopPageProductSolitonUser/TopPageProductDetailSolitonUser';
import TopPageProductSuperDetailSolitonUser from 'page/Application/ManageProductAndService/TopPageProductSolitonUser/TopPageProductSuperDetailSolitonUser';
import TopPageSolitonUser from 'page/Application/ManageProductAndService/TopPageProductSolitonUser/TopPageSolitonUser';
import { Outlet } from 'react-router-dom';

const TopPageProductPartnerUser = () => {
  return <Outlet />;
};

export default TopPageProductPartnerUser;

export {
  DetailNotifySolitonUser,
  TopPageProductDetailSolitonUser,
  TopPageProductSuperDetailSolitonUser,
  TopPageSolitonUser
};

